export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/[0.04] rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/[0.05] rounded-full blur-3xl -translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          {/* Left: Text content */}
          <div className="flex-1 w-full text-center lg:text-left pt-8 md:pt-12">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-accent-500/15 border border-accent-500/30 rounded-full px-4 py-1.5 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-400 whitespace-nowrap">
                8090后专属影视平台
              </span>
            </div>

            {/* H1 */}
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight tracking-tight">
              90影院
              <span className="block text-primary-500 mt-1">
                热门影视免费在线观看
              </span>
            </h1>

            {/* Slogan */}
            <p className="mt-4 text-base md:text-lg text-foreground-300 font-medium">
              高清不缓冲 · 每日更新 · 全集不断
            </p>

            {/* Description */}
            <p className="mt-5 text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0">
              90影院是一个专为8090后打造的综合性免费影视在线平台，汇聚海量电影、电视剧、综艺、动漫资源。从经典老片到最新热播剧，从国产佳作到海外精品，高清画质流畅播放，无需注册即可畅享，满足你所有的追剧需求。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-7">
              {[
                { value: '10万+', label: '影视资源' },
                { value: '99%', label: '高清覆盖' },
                { value: '每日更新', label: '永不断更' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-full text-sm transition-all duration-200 text-center"
              >
                <i className="ri-play-circle-line mr-1.5"></i>
                立即观影
              </a>
              <a
                href="#app"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-background-200/70 hover:bg-background-200 border border-background-300/50 hover:border-foreground-300/40 text-foreground-200 font-medium rounded-full text-sm transition-all duration-200 text-center"
              >
                <i className="ri-download-2-line mr-1.5"></i>
                下载APP
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3]">
              {/* Main image */}
              <div className="relative z-10 rounded-2xl overflow-hidden border border-background-300/40 w-full h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20dramatic%20golden%20spotlight%2C%20film%20projector%20beam%2C%20movie%20posters%20wall%20background%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20vintage%20cinema%20atmosphere%2C%20elegant%20composition%2C%20theater%20curtain%20edges%2C%20epic%20cinematic%20mood&width=1000&height=750&seq=hero-main-2026&orientation=landscape"
                  alt="90影院 - 热门影视在线平台"
                  className="w-full h-full object-cover"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-tr from-background-50/40 via-transparent to-transparent"></div>
              </div>

              {/* Floating badges */}
              <div className="absolute -top-3 -left-3 z-20 bg-background-100/95 backdrop-blur-sm border border-primary-500/40 rounded-xl px-4 py-2.5 flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-500 text-base"></i>
                </div>
                <div>
                  <div className="text-xs font-bold text-primary-500">今日热播</div>
                  <div className="text-[10px] text-foreground-400">庆余年2 · 死侍金刚狼</div>
                </div>
              </div>

              <div className="absolute -bottom-3 -right-3 z-20 bg-background-100/95 backdrop-blur-sm border border-accent-500/40 rounded-xl px-4 py-2.5 flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-accent-500 text-base"></i>
                </div>
                <div>
                  <div className="text-xs font-bold text-accent-400">实时更新</div>
                  <div className="text-[10px] text-foreground-400">2小时极速上线</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}